import React, { useEffect, useState } from 'react';
import MultipleQuotesPageStyle from './style';
import { useLocation, Outlet } from 'react-router-dom';
import useQueryApi from 'src/hooks/useApiQuery';
import { getQuoteDetailVersion } from 'src/api/apiGetQuoteDetailVersion';
import { setContentful } from 'src/redux/actions/contentfulAction';
import { setQuoteDetail } from 'src/redux/actions/quoteDetailAction';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import { setItinerary } from 'src/redux/actions/itineraryAction';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { contentfulSelector } from 'src/redux/selectors/contentfulSelector';
import isEmpty from 'lodash/isEmpty';
import Loading from 'src/components/loading';
import { setMultipleQuotesAction } from 'src/redux/actions/multipleQuotesAction';
import HeaderQuoteDetail from '../quoteDetail/header';
import NavbarQuoteDetail from '../quoteDetail/navbar';
import FooterQuoteDetail from '../quoteDetail/footer';
import { multipleQuotesSelector } from 'src/redux/selectors/multipleQuotesSelector';

const MultipleQuotesPage = () => {
    const location: any = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [quoteId, setQuoteId] = useState(queryParams.get('id') || '');
    const dispatch = useDispatch();

    const { data: dataVersion, isFetched: isLoadingVersion } = useQueryApi(
        ['id', quoteId],
        () => getQuoteDetailVersion(quoteId),
        {
            enabled: !!quoteId,
        },
    );

    const { currentId } = useSelector(multipleQuotesSelector);

    useEffect(() => {
        if (currentId) {
            setQuoteId(currentId);
        }
    }, [currentId]);

    useEffect(() => {
        const data = (dataVersion as { data: any })?.data;
        if (data?.versionId) {
            if (data?.quotes?.length > 1) {
                dispatch(
                    setMultipleQuotesAction({
                        ids:
                            data?.quotes?.map(
                                (quote: any) => quote?.versionId,
                            ) || [],
                        compareQuotes: data?.quotes,
                        versionId: data?.versionId,
                        currentId: data?.quotes[0]?.versionId,
                    }),
                );
                setQuoteId(data?.quotes[0]?.versionId);
            }
        } else {
            setTimeout(() => {
                setDataQuote(
                    data?.contentful,
                    data?.introduction,
                    data?.quoteItinerary,
                );
            }, 50);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataVersion, isLoadingVersion]);

    const setDataQuote = (
        contentfulData: any,
        quoteDetailData: any,
        itinerary: any,
    ) => {
        if (contentfulData) {
            dispatch(setContentful(contentfulData));
        }
        if (quoteDetailData) {
            dispatch(setQuoteDetail(quoteDetailData));
        }
        if (itinerary) {
            dispatch(setItinerary(itinerary));
        }
    };

    const quoteDetail = useSelector(quoteDetailSelector);
    const contentfulData = useSelector(contentfulSelector);

    return (
        <>
            {!isLoadingVersion && <Loading />}
            {!isEmpty(quoteDetail) && !isEmpty(contentfulData) && (
                <MultipleQuotesPageStyle>
                    <HeaderQuoteDetail isPreview={false} />
                    <div className="container-ydp detail-content">
                        <Row gutter={[16, 16]}>
                            <Col span={24} lg={{ order: 2, span: 7 }}>
                                <NavbarQuoteDetail isPreview={false} />
                            </Col>
                            <Col
                                span={24}
                                lg={{ order: 1, span: 17 }}
                                id="quote-detail"
                            >
                                <Outlet />
                            </Col>
                        </Row>
                    </div>
                    <FooterQuoteDetail isPreview={false} />
                </MultipleQuotesPageStyle>
            )}
        </>
    );
};

export default MultipleQuotesPage;
